<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>手机绑定</router-link>
	</div>
	<div class="ld-panel-main">
		<div v-if="!checkToken"><code-verification :secver-type="secverType" @tokenChange="getToken" /></div>
		<el-form v-else :rules="rules" ref="ruleFormRef" inline-message :model="groupForm" :label-width="formLabelWidth" class="form-main">
			<el-form-item label="会员ID">
				<el-input v-model="userid" disabled />
			</el-form-item>
			<el-form-item label="新手机号码" prop="mobile">
				<el-input v-model="groupForm.mobile" autocomplete="off" @change="mobileChange" />
			</el-form-item>
			<div class="code">
			  <el-form-item label="验证码" prop="code">
			    <el-input v-model="groupForm.code" autocomplete="off" />
			  </el-form-item>
			  <el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
			</div>
			<el-form-item>
				<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
			</el-form-item>
		</el-form>
		<code-Captcha v-model="captchaVisible" :secver-type="secverType" :code-type="codeType" @mobileSendCode="sendCode" />
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import Cookies from 'js-cookie';
	import { changeMobile } from '@/api/account';
	import sideNav from '../../components/sideNav.vue';
	import codeVerification from '../../components/codeVerification.vue';
	import codeCaptcha from '../../components/codeCaptcha.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const checkToken = ref(false);
	const authWay = ref('');
	const secverType = 'bindingmobile';
	const codeType = ref('');
	const userid = Cookies.get('LDUSERNAME');
	const captchaVisible = ref(false);
	const codeSendText = ref('获取验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const formLabelWidth = ref('160px');
	const ruleFormRef = ref(null);
	const groupForm = ref({mobile:'',code:''});
	const rules = reactive({
		mobile: [
			{ required: true, message: '请填写新手机号码', trigger: 'blur' }
		],
		code: [
			{ required: true, message: '请填写新手机号码验证码', trigger: 'blur' }
		]
	});
	
	
	
	const getToken = (token,way) =>{
		checkToken.value = token;
		authWay.value = way;
	};
	const mobileChange = (val) => {
		codeType.value = val;
	}
	const codeChange = () => {
		captchaVisible.value = !captchaVisible.value
	};
	const sendCode = (val) =>{
		if (val) {
			codeSend.value = true;
			codeSendText.value = codeTime.value+'s后重新发送';
			let timer = setInterval(() => {
			   codeTime.value--;
			   codeSendText.value = codeTime.value + 's后重新发送';
			   if (codeTime.value < 0) {
				   clearInterval(timer);
				   codeSendText.value = '获取验证码';
				   codeTime.value = 60;
				   codeSend.value = false
			   }
			}, 1000)
			captchaVisible.value = !captchaVisible.value;
		}
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['way'] = authWay.value;
				changeMobile(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						router.back();
					}
				})
			} else {
			  return false;
			}
		});
	};
	
</script>

<style lang="scss" scoped>
	.code{
		overflow: hidden;
		.el-form-item{
			width: 42%;
			float: left;
			.el-input{width: 100%; margin-right: 20px;}
		}
	}
</style>